import React from 'react'
import { useRecoilValue } from 'recoil'
import PropTypes from 'prop-types'

import { Flex, IconClose } from 'mailup-web-components'
import styled from '@emotion/styled'

import { previewState } from 'Pages/PreviewMessage/recoil/state/preview'

const ShowPersonalization = ({ onClose }) => {
  const { recipient } = useRecoilValue(previewState)

  if (!recipient) return null

  return (
    <Flex
      width='100%'
      height='65px'
      padding='0 24px'
      justifyContent='flex-end'
      alignItems='flex-end'
    >
      <StyledIconWrapper onClick={onClose}>
        <IconClose />
      </StyledIconWrapper>
    </Flex>
  )
}

export default ShowPersonalization

const StyledIconWrapper = styled.span`
  width: 44px;
  height: 44px;
  text-align: center;
  font-size: 16px;
  background-color: var(--wild-sand);
  border-radius: 50%;
  cursor: pointer;

  display: flex;
  align-items: center;
  justify-content: center;

  .c-svg-icon {
    color: hsla(0, 0%, 65.9%, 0.5);
  }
`
ShowPersonalization.propTypes = {
  onClose: PropTypes.func
}
